import { MANUS_IMPORT_MAX_AGENTS_PER_REQUEST } from "../constants/manus-import";
import type {
  IImportManusAgentsPayload,
  IListManusAgentsPayload,
  IManusAgent,
  IManusAgentImportResult,
} from "../types";
import type { ApiClient } from "./client";
import { importInBatches } from "./import-in-batches";

export class ManusImportApi {
  constructor(private readonly apiClient: ApiClient) {}

  async listAgents(data: IListManusAgentsPayload): Promise<IManusAgent[]> {
    const response = await this.apiClient.post<IManusAgent[]>(
      "/integrations/manus/agents",
      data,
    );
    return response.data;
  }

  // NOTE: Batched like every agent import — see importInBatches.
  async importAgents({
    apiKey,
    agents,
  }: IImportManusAgentsPayload): Promise<IManusAgentImportResult[]> {
    return importInBatches({
      agents,
      batchSize: MANUS_IMPORT_MAX_AGENTS_PER_REQUEST,
      sendBatch: async (batch) => {
        const response = await this.apiClient.post<IManusAgentImportResult[]>(
          "/integrations/manus/agents/import",
          { apiKey, agents: batch },
        );
        return response.data;
      },
    });
  }
}
